import client, { getEnvVariable } from "../axios";
import Hex from "crypto-js/enc-hex";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { DefaultService } from "./DefaultService";
import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { HttpStatusCode } from "../HttpStatusCode";

export default class PatientService extends DefaultService {
  public static readonly entityUrl = "/patients";

  private static async buildAuthorizationHeader(path: string): Promise<string> {
    const apiUrl = await getEnvVariable("VUE_APP_API_URL");
    const apiKey = await getEnvVariable("VUE_APP_API_KEY");
    const apiBaseUrl = new URL(apiUrl);
    const normalizedBasePath = apiBaseUrl.pathname.replace(/\/+$/, "");
    const normalizedRequestPath = path.replace(/^\/+/, "");
    const signedPayload = `${apiBaseUrl.host}${normalizedBasePath}/${normalizedRequestPath}`;
    return Hex.stringify(HmacSHA256(signedPayload, apiKey));
  }

  static getPatient(
    clinic_id: number | string,
    patient_document: string
  ): Promise<PatientInterface> {
    const document = patient_document.replace(/\D/g, "");
    const requestPath = `${this.entityUrl}/getInClinic/${clinic_id}/${document}`;

    return new Promise((resolve, reject) => {
      this.buildAuthorizationHeader(requestPath)
        .then((authorization) =>
          client.get(requestPath, {
            headers: { Authorization: authorization },
          })
        )
        .then((response: any) => {
          if (response.status === HttpStatusCode.OK) resolve(response.data.data);
          else reject(response.statusText);
        })
        .catch((error: any) => reject(error));
    });
  }

  static getPatientEmail(
    clinic_id: number | string,
    email: string
  ): Promise<PatientInterface> {
    const requestPath = `${this.entityUrl}/getEmailInClinic/${clinic_id}/${encodeURIComponent(email)}`;

    return new Promise((resolve, reject) => {
      this.buildAuthorizationHeader(requestPath)
        .then((authorization) =>
          client.get(requestPath, {
            headers: { Authorization: authorization },
          })
        )
        .then((response: any) => {
          if (response.status === HttpStatusCode.OK) resolve(response.data.data);
          else reject(response.statusText);
        })
        .catch((error: any) => reject(error));
    });
  }
}
